import axios from 'axios';
import { getAuthToken } from '../utils/authUtils';

// Use environment variable or fallback to localhost for development
const API_BASE = process.env.REACT_APP_FIREBASE_BACKEND_API_BASE || 'https://quantumleap-emr-dev.web.app';



async function getAuthHeaders() {
  const token = await getAuthToken();
  if (!token) {
    throw new Error('No authentication token available');
  }
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
}

export async function getMasterWorkflowConfig() {
  console.log('🚀 Calling getMasterWorkflowConfig, API_BASE:', API_BASE);
  console.log('🔗 Full URL:', `${API_BASE}/facility/workflow-config/master`);
  
  try {
    const headers = await getAuthHeaders();
    console.log('📋 Request headers:', headers);
    
    const res = await axios.get(`${API_BASE}/facility/workflow-config/master`, { headers });
    console.log('✅ Master workflow config response:', res.data);
    return res.data;
  } catch (error) {
    console.error('❌ Error in getMasterWorkflowConfig:', error);
    console.error('❌ Error response:', error.response?.data);
    console.error('❌ Error status:', error.response?.status);
    throw error;
  }
}

export async function updateMasterWorkflowConfig(steps, token) {
  console.log('🚀 Calling updateMasterWorkflowConfig, API_BASE:', API_BASE);
  console.log('🔗 Full URL:', `${API_BASE}/facility/workflow-config/master`);
  
  try {
    const headers = await getAuthHeaders();
    console.log('📋 Request headers:', headers);
    
    const res = await axios.put(`${API_BASE}/facility/workflow-config/master`, { steps }, { headers });
    console.log('✅ Update master workflow config response:', res.data);
    return res.data;
  } catch (error) {
    console.error('❌ Error in updateMasterWorkflowConfig:', error);
    console.error('❌ Error response:', error.response?.data);
    console.error('❌ Error status:', error.response?.status);
    throw error;
  }
}

export async function getFacilityWorkflowConfig(facilityId) {
  console.log('🏥 Calling getFacilityWorkflowConfig for facility:', facilityId);
  console.log('🔗 Full URL:', `${API_BASE}/facility/facilities/${facilityId}/workflow-config`);
  
  try {
    const headers = await getAuthHeaders();
    console.log('📋 Request headers:', headers);
    
    const res = await axios.get(`${API_BASE}/facility/facilities/${facilityId}/workflow-config`, { headers });
    console.log('✅ Facility workflow config response:', res.data);
    return res.data;
  } catch (error) {
    console.error('❌ Error in getFacilityWorkflowConfig:', error);
    console.error('❌ Error response:', error.response?.data);
    console.error('❌ Error status:', error.response?.status);
    throw error;
  }
}

export async function updateFacilityWorkflowConfig(facilityId, steps, token) {
  console.log('🏥 Calling updateFacilityWorkflowConfig for facility:', facilityId);
  console.log('🔗 Full URL:', `${API_BASE}/facility/facilities/${facilityId}/workflow-config`);
  
  try {
    const headers = await getAuthHeaders();
    console.log('📋 Request headers:', headers);
    
    const res = await axios.put(`${API_BASE}/facility/facilities/${facilityId}/workflow-config`, { steps }, { headers });
    console.log('✅ Update facility workflow config response:', res.data);
    return res.data;
  } catch (error) {
    console.error('❌ Error in updateFacilityWorkflowConfig:', error);
    console.error('❌ Error response:', error.response?.data);
    console.error('❌ Error status:', error.response?.status);
    throw error;
  }
} 